export { DayOfWeekDto as DayOfWeek, TimeAccessTypeDto as TimeAccessType } from '@treasury/api/bo';
export type TimeAccessTypeLabel = 'Unlimited' | 'No Access' | 'Time Range';
